<template>
  <button
    :class="{ appButton_loading: loading }"
    :disabled="locked"
    class="appButton global-button-text"
    @click.prevent="$emit('click')"
  >
    <template v-if="!loading">{{ text }}</template>
  </button>
</template>

<script>
export default {
  name: "AppButton",
  props: {
    text: {
      type: String,
      default: "button",
    },
    to: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    locked() {
      return this.disabled || this.loading;
    },
  },
  emits: ["click"],
};
</script>

<style lang="scss">
.appButton {
  height: 48px;
  background: var(--color-button);
  font-family: var(--font-family-button);
  border-radius: 12px;
  width: 100%;
  padding: 13px 0;
  text-align: center;
  color: var(--color-text-button);
  border: none;
  display: block;
  text-decoration: none;
  cursor: pointer;
  position: relative;

  &_loading {
    display: flex;
    font-size: 0;
    justify-content: center;
    align-items: center;

    &:after {
      -webkit-animation: rotating 2s linear infinite;
      -moz-animation: rotating 2s linear infinite;
      -ms-animation: rotating 2s linear infinite;
      -o-animation: rotating 2s linear infinite;
      animation: rotating 2s linear infinite;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23.2218 14.8729C23.7019 15.0016 24.199 14.717 24.2913 14.2285C24.7335 11.889 24.4707 9.46315 23.5255 7.26309C22.4615 4.78656 20.5947 2.74036 18.2259 1.45421C15.8571 0.168066 13.1243 -0.283124 10.4678 0.173345C7.81132 0.629814 5.38587 1.96736 3.58227 3.97045C1.77868 5.97354 0.701993 8.52552 0.525703 11.2152C0.349414 13.9048 1.08379 16.5755 2.6105 18.7969C4.1372 21.0183 6.36732 22.6609 8.94151 23.4603C11.2283 24.1703 13.6683 24.1781 15.9488 23.4937C16.4249 23.3509 16.656 22.8268 16.4779 22.3628C16.2998 21.8987 15.7799 21.6711 15.302 21.8076C13.4009 22.3508 11.3758 22.3314 9.47528 21.7412C7.28723 21.0618 5.39162 19.6655 4.09392 17.7774C2.79622 15.8892 2.172 13.6191 2.32185 11.3329C2.47169 9.0467 3.38688 6.87751 4.91993 5.17488C6.45299 3.47226 8.51463 2.33534 10.7726 1.94735C13.0307 1.55935 15.3536 1.94286 17.367 3.03608C19.3805 4.12931 20.9673 5.86858 21.8717 7.97363C22.6572 9.80209 22.8882 11.814 22.5468 13.7615C22.4609 14.251 22.7417 14.7443 23.2218 14.8729Z' fill='white'/%3E%3C/svg%3E");
      content: "";
      height: 24px;
      width: 24px;
      display: block;
      position: absolute;
    }
  }

  &:hover {
    opacity: 0.8;
  }

  &[disabled] {
    cursor: initial;
    opacity: 0.6;
  }
}

@-webkit-keyframes rotating /* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
